export class Evaluation {
	public _id?: string
	public type?: string
	public order?: number
	public companyId?: string
	public version?: string
	public question?: string
	public description?: string
	public mandatory_question?: boolean
	public mandatory_photo?: boolean
	public multiple_answer?: boolean
	public scale?: {
		checked?: boolean
		value?: number
	}
	public alternatives?: Array<{
		text?: string
		order?: number
		value?: number
		color?: string
		isDefaultForUnscheduledOperation?: boolean;
	}>
	public other?: {
		checked?: boolean
		text?: string
	}
	public created_date?: Date
	public edit_date?: Date
	public status?: string
	public user?: string

	constructor() {
		this.scale = {
			checked: false,
			value: undefined
		}
		this.alternatives = []
		this.other = {
			checked: false,
			text: undefined
		}
	}
}
